export { default } from './DetailModalShell';
